import { useEffect, useState } from "react";
import { Api_Url } from "../../utils/ApiUrl";

const useActivityLogs = () => {
    const Apiurl = Api_Url;
    const accessToken = localStorage.getItem("accessToken");

    const [activityData, setActivityData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
    });

    const fetchActivityLogs = async (
        page = 1,
        limit = 10,
        orderDirection = -1,
        orderField = "createdAt"
    ) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${Apiurl}/logs?offset=${page}&limit=${limit}&orderDirection=${orderDirection}&orderField=${orderField}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(
                    `Failed to fetch activity logs: ${response.status} - ${errorData?.message || response.statusText}`
                );
            }

            const data = await response.json();

            setPagination({
                currentPage: page,
                totalPages: data.data.pages,
                totalCount: data.data.count,
                limit,
            });

            setActivityData(data.data.activityLogs);
        } catch (error) {
            setError(error);
            console.error("Error fetching activity logs:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActivityLogs();
    }, [Apiurl, accessToken]);

    return {
        activityData,
        loading,
        error,
        pagination,
        fetchActivityLogs,
    };
};

export default useActivityLogs;
